import { TextField } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

InputField.propTypes = {
  column: PropTypes.instanceOf().isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  type: PropTypes.string,
};

const useStyles = makeStyles()((theme) => ({
  Row: {
    marginTop: 20,
  },
}));

function InputField(props) {
  const { value, column, id, label = null, defaultValue = null, onChange = null, disabled = false, type = 'text' } = props;
  const [inputValue, setInputValue] = useState(null);
  const { classes } = useStyles();

  useEffect(() => {
    setInputValue(value);
  });

  function handleInputChange(e) {
    setInputValue(e.target.value);
    if (onChange) {
      onChange(e);
    }
  }

  return (
    <Grid className={classes.Row} size={column}>
      <span>
        {label}
        <i></i>
      </span>
      <TextField type={type} inputA id={id} key={id} value={inputValue} disabled={disabled} variant="outlined" fullWidth size="small" onChange={handleInputChange} />
    </Grid>
  );
}

export default InputField;
